module.exports = __webpack_public_path__ + "static/media/cancel_outline_large.645642d6.svg";